import { getOrderById, getOrdersList, updateOrderApi } from '@/services/OrderManagementService';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getOrders = createAsyncThunk('orderManagement/data/getOrders', async ({ filter, select }) => {
  console.log('response.getOrders', filter, select);
  const response = await getOrdersList({ filter: filter, select: select });
  console.log('response.getOrders response', response.data.data);
  return response.data.data;
});

export const getOrder = createAsyncThunk('orderManagement/data/getOrder', async (id) => {
  const response = await getOrderById({ _id: id });
  console.log('response.data.data;', response.data.data[0]);
  return response.data.data[0];
});
export const updateOrderData = createAsyncThunk('orderManagement/data/updateOrderData', async (body) => {
  // const data = { action: type, payload: orderUpdateFields };
  const response = await updateOrderApi({ _id: body.id }, { data: body.data });

  return response.data.data;
});

const dataSlice = createSlice({
  name: 'orderManagement/data',
  initialState: {
    orderListLoading: false,
    OrderLoading: false,
    orderList: [],
    order: {},
    selectedOrderId: '',
  },
  reducers: {
    updateorderList: (state, action) => {
      state.orderList = action.payload;
      console.log('state.orderList', state.orderList);
    },
    appendOrderList: (state, action) => {
      console.log('state.appendOrderList (before)', state.orderList);

      // Create a shallow copy of the state.orderList array
      const newOrderList = [...state.orderList];

      // Add the new order at the beginning of the newOrderList array
      newOrderList.unshift(action.payload);

      // Update the state.orderList with the newOrderList array
      state.orderList = newOrderList;

      console.log('state.appendOrderList (after)', state.orderList, action.payload);
    },
    updateOrder: (state, action) => {
      state.order = action.payload;
    },
    updateOrderId: (state, action) => {
      console.log('action=========================>', action);
      state.selectedOrderId = action.payload;
    },
  },
  extraReducers: {
    [getOrders.fulfilled]: (state, action) => {
      state.orderListLoading = false;
      state.orderList = action.payload;
    },
    [getOrders.rejected]: (state, action) => {
      state.orderListLoading = false;
      state.order = action.payload;
    },
    [getOrders.pending]: (state) => {
      state.orderListLoading = true;
    },
    [getOrder.fulfilled]: (state, action) => {
      console.log('Accepted');
      state.OrderLoading = false;
      state.order = action.payload;
    },
    [getOrder.rejected]: (state, action) => {
      console.log('rejected');
      state.OrderLoading = false;
    },
    [getOrder.pending]: (state) => {
      console.log('pending');
      state.OrderLoading = true;
    },
    [updateOrderData.fulfilled]: (state, action) => {
      state.order = action.payload;
    },
  },
});

export const { updateorderList, appendOrderList, updateOrder, updateOrderId } = dataSlice.actions;

export default dataSlice.reducer;
